import { useTranslation } from 'react-i18next';
import { Field } from 'app/components/core/Form';
import { Input } from 'app/components/core/Input';

export function JobNameField({ name = 'name', readOnly = false }) {
    const { t } = useTranslation();

    return (
        <Field
            component={Input}
            name={name}
            label={t('common:name')}
            placeholder={t('jobs:definitions.name_placeholder')}
            readOnly={readOnly}
        />
    );
}
